<div class="sticker-message">
  <div class="sticker-wrapper">
    <div class="sticker" [ngStyle]="{'background-image': imgSrc}"></div>
  </div>
</div>